class SccProductShare extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.button = this.querySelector('button');
    this.status = this.querySelector('[data-share-status]');
    this.defaultLabel = this.querySelector('[data-share-label]')?.textContent || '';
    this.button?.addEventListener('click', this.shareProduct);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.shareProduct);
    window.clearTimeout(this.resetTimer);
  }

  shareProduct = async () => {
    if (!this.button || this.button.disabled) return;

    this.button.disabled = true;
    const title = this.dataset.productTitle || document.title;
    const url = this.dataset.productUrl || window.location.href;

    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title, url });
        this.button.disabled = false;
        return;
      } catch (error) {
        if (error?.name === 'AbortError') {
          this.button.disabled = false;
          return;
        }
      }
    }

    const copied = await this.copyLink(url);
    this.showResult(copied ? this.dataset.copiedLabel : this.dataset.errorLabel);
    this.button.disabled = false;
  };

  async copyLink(url) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        return true;
      } catch {
        // Permission-restricted contexts can expose Clipboard API but reject writes.
      }
    }

    let fallback;
    try {
      fallback = document.createElement('textarea');
      fallback.value = url;
      fallback.setAttribute('readonly', '');
      fallback.style.position = 'fixed';
      fallback.style.opacity = '0';
      document.body.appendChild(fallback);
      fallback.select();
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      fallback?.remove();
    }
  }

  showResult(message) {
    if (!message) return;

    const label = this.querySelector('[data-share-label]');
    if (label) label.textContent = message;
    if (this.status) this.status.textContent = message;

    window.clearTimeout(this.resetTimer);
    this.resetTimer = window.setTimeout(() => {
      if (label) label.textContent = this.defaultLabel;
      if (this.status) this.status.textContent = '';
    }, 2500);
  }
}

if (!customElements.get('scc-product-share')) {
  customElements.define('scc-product-share', SccProductShare);
}
